module.exports = __webpack_public_path__ + "static/media/item_2_1.4339bbae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_1.png
// module id = 108
// module chunks = 0